import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import React from "react";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import HubStatistic from "./HubStatistic";
import RunnerStatistic from "./RunnerStatistic";
import "./style.scss";

const OrderStatistic = () => {
  const { t } = useTranslation(["orderStatistic"]);
  return (
    <div className="page-content">
      <MetaTags>
        <title>{t("title")}</title>
      </MetaTags>
      <div className="container-fluid">
        <BreadcrumbWithLink title={t("title")} />
        <Row>
          <Col xs={12} lg={4}>
            <Card>
              <CardHeader className="bg-white">
                <h5 className="mt-3">{t("titleByHub")}</h5>
              </CardHeader>
              <CardBody>
                <HubStatistic />
              </CardBody>
            </Card>
          </Col>
          <Col xs={12} lg={8}>
            <Card>
              <CardHeader className="bg-white">
                <h5 className="mt-3">{t("titleByRunner")}</h5>
              </CardHeader>
              <CardBody>
                <RunnerStatistic />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default OrderStatistic;
